import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d9503c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-feedback-modal__title" }
const _hoisted_2 = {
  key: 0,
  class: "app-feedback-modal__buttons-wrapper"
}
const _hoisted_3 = { class: "app-feedback-modal__text" }

import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import { IonIcon } from '@ionic/vue';
import { AppFeedbackType } from '@/types/ui';
import { computed } from 'vue';
import { thumbsDown, thumbsUp } from 'ionicons/icons';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFeedbackModal',
  props: {
    isOpened: { type: Boolean },
    type: {}
  },
  emits: ['close', 'like', 'dislike', 'review', 'contact'],
  setup(__props: any, { emit: __emit }) {

const { t } = useInternalization();

const props = __props;
const emit = __emit;

const modalTitle = computed(() =>
  props.type === 'initial'
    ? t('modals.appFeedbackQuestionTitle')
    : t('modals.appFeedbackResponseTitle')
);

const modalText = computed(() => {
  if (props.type === 'initial') {
    return t('modals.appFeedbackQuestionText');
  } else if (props.type === 'negative') {
    return t('modals.appFeedbackNegativeResponseText');
  } else {
    return t('modals.appFeedbackPositiveResponseText');
  }
});

function close() {
  if (props.isOpened) {
    emit('close');
  }
}
function handleLike() {
  emit('like');
}
function handleDislike() {
  emit('dislike');
}
function handleReveiw() {
  emit('review');
}
function handleContact() {
  emit('contact');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    class: "app-feedback-modal",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(modalTitle.value), 1),
      (_ctx.type === 'initial')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(BaseButton, {
              primary: "",
              class: "modal__btn",
              onClick: handleLike
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('yes')), 1),
                _createVNode(_unref(IonIcon), { icon: _unref(thumbsUp) }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(BaseButton, {
              secondary: "",
              class: "modal__btn",
              onClick: handleDislike
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('no')) + " ", 1),
                _createVNode(_unref(IonIcon), { icon: _unref(thumbsDown) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(modalText.value), 1),
      (_ctx.type === 'initial')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "app-feedback-modal__later-btn",
            onClick: close
          }, _toDisplayString(_unref(t)('reviewLater')), 1))
        : (_ctx.type === 'negative')
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 2,
              onClick: handleContact
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('contactUs')), 1)
              ]),
              _: 1
            }))
          : (_ctx.type === 'positive')
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 3,
                onClick: handleReveiw
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('leaveReview')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-opened"]))
}
}

})